export default "__VITE_ASSET__DY1Fnu3$__"